module.exports = __webpack_public_path__ + "src/assets/textures/env/hay/wagon_hay_01_512_bake.png";